"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const TabsSet_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/TabsSet.vue"));
const Tab_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Tab.vue"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const MapParcels_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/MapParcels"));
const BaseMapConnector_1 = require("@becrop/components/Toolkit/Common/models/BaseMapConnector");
const BaseMap_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BaseMap.vue"));
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
let Map = class Map extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.connector = new BaseMapConnector_1.BaseMapConnector(this.map_config);
    }
    async onChangeActive() {
        this.loading = true;
        await this.connector.draw();
        await this.drawParcels();
        await (0, sleep_1.default)(300);
        this.loading = false;
    }
    async drawParcels() {
        if (!this.heatmap.root) {
            console.warn('There is no heatmap root');
            return;
        }
        const parcels2Draw = await MapParcels_1.default.load(this.heatmap.root);
        this.connector.reset();
        parcels2Draw.forEach((parcel) => {
            this.connector.drawPolygon({
                color: parcel.cluster_color,
                shape: parcel.parcel_str,
            });
            parcel.muestras.forEach((m) => {
                this.connector.drawMarker({
                    color: parcel.cluster_color,
                    text: m.cluster_text,
                    lat: m.tierra.latitud,
                    lon: m.tierra.longitud,
                });
            });
        });
        this.connector.center();
    }
    closeMap() {
        this.$emit('onclosemap');
    }
    downloadMap() {
        this.connector.download();
    }
    // goFullscreenMap() {
    //     this.$emit('toggleFSMap');
    // }
    onFullscreenChange(fullscreen) {
        this.fsactivemap = fullscreen;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Map.prototype, "active", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Map.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Map.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Map.prototype, "fsactivemap", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('active')
], Map.prototype, "onChangeActive", null);
Map = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapAttributions: bmk_ui_framework_1.MapAttributions,
            TabsSet: TabsSet_vue_1.default,
            Tab: Tab_vue_1.default,
            Download: lucide_vue_next_1.Download,
            Maximize2: lucide_vue_next_1.Maximize2,
            X: lucide_vue_next_1.X,
            Info: lucide_vue_next_1.Info,
            HelpCircle: lucide_vue_next_1.HelpCircle,
            Loader: Loader_vue_1.default,
            BaseMap: BaseMap_vue_1.default,
        },
    })
], Map);
exports.default = Map;
